import Content from './Content/Content'
import Options from './Options/Options'


const AboutUsContainer = () => {
    return (
        <>
            <Content />
            <Options />
        </>
    )
}

export default AboutUsContainer